//import { J3Sample } from './J3Sample';
import { J3ThreeMain } from './J3ThreeMain';
//import {DebugVar } from './J3TypeList'; //デバッグ用オブジェクト

// declare this file is a module
export { };
// ===== Pre-Process
// デバッグ設定1（コンソール）
//let debugLvl: number = 2;

//MP Showcase要素の作成。
window.addEventListener('DOMContentLoaded', function () {
  //HTMLページが読み込まれてから実行。
  console.log("DOMContentLoaded");
  //const j3Sample = new J3Sample();
  //j3Sample.Init();
  const j3Main = new J3ThreeMain();
  j3Main.Init();

});
